/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_EstonianInputs */



/**
* | output |
* | --- |
* | "Estonian" |
*
* @param {Speechmatics_Target_Language_EstonianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_estonian = /** @type {((inputs?: Speechmatics_Target_Language_EstonianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_EstonianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Estonien")
	if (locale === "de") return /** @type {LocalizedString} */ ("estnisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("estone")
	if (locale === "ru") return /** @type {LocalizedString} */ ("эстонский")
	if (locale === "es") return /** @type {LocalizedString} */ ("estonio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("爱沙尼亚语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エストニア語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एस्तोनियावासी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("estoniano")
	return /** @type {LocalizedString} */ ("Estonian")
});